import React from 'react'

const SignupForm = ({ blockId }) => (
	<aside id={blockId} className="max-w-screen-xl mx-auto">
		<iframe
			src="/sign-up-form"
			className="w-full min-h-[435px]"
		/>
	</aside>
)

export default SignupForm
